<template>
<div id="root-content">
  <site-header v-if="!hideFooterHeader" />
  <router-view />
  <site-footer v-if="!hideFooterHeader" />
</div>
</template>

<script>
import store from "./store"
export default {
  name: 'Root',
  computed:{
    hideFooterHeader(){
      // return !this.$store.hideHeaderFooter
      return store.state.hideHeaderFooter
      // return true;
    }
  },
  mounted() {
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  font-size:12px;
  font-family: 'Microsoft YaHei',微软雅黑;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  --fontSizeI:12px;
  --fontSizeII:14px;
  --fontSizeIII:16px;
  --fontSizeIIII:18px;

  --color0:#ffffff;
  --color1:#598118;
  --color2:#BE550F;
  --color3:#68352F-#BE550F;
  --color4:#598118-#D1DA4D;
  --color5:#598118-#BE550F;
  --color6:#F1A100;
  --color7:#477931;
  --color99:#000000;
  --colorR:red;
  --colorG:green;
  --colorB:blue;
  --colorY:yellow;
  background-color: #ee;
}

h1,
h2 {
  font-weight: normal;
}
a {
  color: #42b983;
  text-decoration: none;
}

.site-content {
  margin: 0 auto;
  width: 100%;
  min-height: 600px;
  background-color: #fff;
}

.site-content-banner {
  margin: 0 auto;
  width: 100%;
  min-height: 100px;
  background-color: #eee;
}

.site-content-banner img{
  display:block;
  margin: 0 auto;
  width: 100%;
  min-height: 100px;
}

.site-content-page {
  margin: 0 auto;
  width: 1024px;
  min-height: 100px;
  background-color: var(--color0);
}

.content-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-top:20px;
}

.content-col {
  flex:1;
  text-align: center;
  width: 100%;
  padding:0px;
}

.content-col + .content-col{
    margin-left: 20px;
}

.content-block {
  width:100%;
  background-color: var(--color0);
  background-color:rgba(0,0,0,0);
}

.width-per-100{
  width:100%;
}

/**组件公共样式*/
.info-list-title{
  position:relative;
  width:100%;
  height:40px;
  border-bottom:1px solid #bbbbbb;
  text-align:left;
  margin-bottom:5px;
}

.info-list-title span{
  padding:10px 5px 8px 5px;
  border-bottom:2px solid #B00B11;
  font-size:14px;
  font-weight:800;
  line-height:40px;
  text-align:left;
}

.info-list-title label{
  font-size:12px;
  font-weight:400;
  color: OrangeRed;
}

.info-list-title a{
  text-decoration: none;
  float:right;
  padding-right:10px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color:#9FA2A6;
}

.info-list-title a:hover{
  color:var(--color6);
}

.info-list-act{
  width:100%;
  height:60px;
  border-bottom:0px solid #bbbbbb;
  text-align:left;
  margin-bottom:0px;
}

.info-detail-title{
  position:relative;
  width:100%;
  height:120px;
  border-bottom:1px solid #bbbbbb;
  text-align:left;
  margin-bottom:5px;
}

.title-info{
  float:left;
  width: calc(100% - 200px);
  text-align:left;
}

.title-act{
  float:left;
  width:200px;
  height:80px;
  text-align:center;
  line-height:80px;
}

.info-detail-title .title{
  display: flex;
  padding:5px 5px 5px 10px;
  height:80px;
  font-size:18px;
  font-weight:800;
  line-height:30px;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
}

.info-detail-title .publisher{
  float:left;
  margin-right:40px;
  margin-left:10px;
  font-size:12px;
  height:30px;
  font-weight:400;
  line-height:30px;
}

.info-detail-title .visits{
  float:left;
  margin-right:40px;
  font-size:12px;
  height:30px;
  font-weight:400;
  line-height:30px;
}

.info-detail-title .date{
  float:left;
  padding-left:20px;
  font-size:12px;
  height:30px;
  font-weight:400;
  line-height:30px;
  background-image:url(./assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 7px;
}

.info-detail-title .collection{
  text-decoration: none;
  padding-right:10px;
  padding-left:20px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color:#9FA2A6;
  background-image:url(./assets/collection.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-title .share{
  text-decoration: none;
  padding-right:10px;
  padding-left:20px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color:#9FA2A6;
  background-image:url(./assets/share.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-content p{
  padding:2px 10px 2px 10px;
  font-size:14px;
  font-weight:0;
  text-align: justify;
  text-indent:2em;
  line-height:35px;
  letter-spacing:0px;
  font-family: Arial,"PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;
  color:#333;
}
.info-detail-content img{max-width:660px;}

.no-record{
  position:relative;
  height:40px;
  background:#eee;
  font-size:12px;
  text-align:center;
  line-height:40px;
  color:#888888;
}

.no-record-1{
  position:relative;
  height:180px;
  width:100%;
  background:#fff;
  font-size:12px;
  text-align:center;
  line-height:40px;
  color:#888888;
  background-image:url(./assets/no_data.png);
  background-size: 197px 128px;
  background-repeat: no-repeat;
  background-position: center 0px;
}
.no-record-1:after{
    content: "暂无数据";
    color: #bfbfbf;
    font-size: 18px;
    text-align:center;
    line-height:300px;
}
.new-img-box {
  width: 250px;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-img-box img {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue